/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNot } from '../../factoriesAny.js';
export var notDependencies = {
  typedDependencies,
  createNot
};